import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import { endpoints } from '@rossum/api-client';
import { PatchUserPayload } from '@rossum/api-client/users';
import { notify } from '../../features/toaster';
import { useApiClient } from '../../lib/apiClient';
import { QUERY_KEY_USER } from './useGetUser';
import { QUERY_KEY_USERS } from './useUsers';

export const usePatchUser = () => {
  const api = useApiClient();
  const queryClient = useQueryClient();
  const intl = useIntl();

  return useMutation({
    mutationFn: ({
      userId,
      payload,
    }: {
      userId: number;
      payload: PatchUserPayload;
    }) => api.request(endpoints.users.patch(userId, payload)),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEY_USERS],
      });
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEY_USER],
      });

      notify.default({
        title: intl.formatMessage({
          id: 'containers.message.userUpdated',
        }),
      });
    },

    onError: () =>
      notify.error({
        title: intl.formatMessage({
          id: 'containers.message.userUpdatedError',
        }),
      }),
  });
};
